import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['select']

  selectEmployee(event) {
    const userId = event.target.value
    const userName = event.target.options[event.target.selectedIndex].text

    this.dispatch('shift-cover-selected', { detail: { userName: userName, userId: userId } } )
  }
}
